import { render, staticRenderFns } from "./ListDelivery.vue?vue&type=template&id=7445855c&scoped=true&"
import script from "./ListDelivery.vue?vue&type=script&lang=ts&"
export * from "./ListDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./ListDelivery.vue?vue&type=style&index=0&id=7445855c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7445855c",
  null
  
)

export default component.exports